import { useState, MouseEvent } from 'react';
import { useNavigate } from 'react-router';

// material-ui
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

// assets
import { Edit2 } from 'iconsax-react';
import { FormattedMessage } from 'react-intl';

// ==============================|| HEADER PROFILE - PROFILE TAB ||============================== //

export default function ProfileTab({ id, onClose, onOpenModal }: { id?: string; onClose?: () => void; onOpenModal?: () => void }) {
  const navigate = useNavigate();
  const [selectedIndex, setSelectedIndex] = useState(0);

  const handleListItemClick = (event: MouseEvent<HTMLDivElement>, index: number, route: string = '') => {
    setSelectedIndex(index);

    if (route && route !== '') {
      navigate(route);
    }
    onClose?.();
  };

  return (
    <>
      <List component="nav" sx={{ p: 0, '& .MuiListItemIcon-root': { minWidth: 32 } }}>
        <ListItemButton
          selected={selectedIndex === 1}
          onClick={() => {
            onOpenModal?.();
            onClose?.();
          }}
          // onClick={(event: MouseEvent<HTMLDivElement>) => handleListItemClick(event, 1, `/admin/edit-profile?id=${id}}`)}
        >
          <ListItemIcon>
            <Edit2 variant="Bulk" size={18} />
          </ListItemIcon>
          <ListItemText primary={<FormattedMessage id="editprofile" />} />
        </ListItemButton>
        {/* <ListItemButton
          selected={selectedIndex === 2}
          onClick={(event: MouseEvent<HTMLDivElement>) => handleListItemClick(event, 2, `/admin/leave-infomation`)}
        >
          <ListItemIcon>
            <Edit2 variant="Bulk" size={18} />
          </ListItemIcon>
          <ListItemText primary={<FormattedMessage id="leaveInfo" />} />
        </ListItemButton> */}
      </List>
    </>
  );
}
